import { MAIN_PAYMENT_URL } from "../Configs/Urls";
import {
  callContinue1,
  callContinue2,
  callProceedToPay,
  GetTheFlight,
  SellTheFlightAPI,
} from "../Redux/Apis/Flight-Apis";
import {
  getBookingDetailed,
  UpdateBookingStatus,
} from "../Redux/Apis/User-Apis";
import { getLocalStorageJSON } from "./localStorageFunc";
import CryptoJS from "crypto-js";

const InitializePopup = (SearchResultType, FlightDetail) => {
  console.log(
    "here the flight detail is inside the initilaise is : ",
    FlightDetail
  );

  if (
    SearchResultType == 1 ||
    SearchResultType == 2 ||
    SearchResultType == 3 ||
    SearchResultType == 4 ||
    SearchResultType == 5 ||
    SearchResultType == 6
  ) {
    if (FlightDetail[0] == undefined) {
      if (
        FlightDetail.Connections[0].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[1].SellResponse.IsPriceChanged == true
      ) {
        let OriginalPriceEarlier1 =
            FlightDetail.Connections[0].Fare.BaseFare +
            FlightDetail.Connections[0].Fare.Tax,
          OriginalPriceEarlier2 =
            FlightDetail.Connections[1].Fare.BaseFare +
            FlightDetail.Connections[1].Fare.Tax;

        if (FlightDetail.Connections[0].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[0].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[0].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier1 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier1 - priceChanged
              : OriginalPriceEarlier1 + priceChanged;
        }

        if (FlightDetail.Connections[1].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[1].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[1].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier2 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier2 - priceChanged
              : OriginalPriceEarlier2 + priceChanged;
        }

        let combinedSum =
          FlightDetail.Connections[0].Fare.BaseFare +
          FlightDetail.Connections[0].Fare.Tax +
          FlightDetail.Connections[1].Fare.BaseFare +
          FlightDetail.Connections[1].Fare.Tax;

        let isPriceChanged =
          combinedSum != OriginalPriceEarlier1 + OriginalPriceEarlier2;

        let priceChanged =
          combinedSum > OriginalPriceEarlier1 + OriginalPriceEarlier2
            ? combinedSum - OriginalPriceEarlier1 + OriginalPriceEarlier2
            : OriginalPriceEarlier1 + OriginalPriceEarlier2 - combinedSum;

        let changeIdentifier =
          combinedSum < OriginalPriceEarlier1 + OriginalPriceEarlier2
            ? "Decreased"
            : "Increased";

        if (isPriceChanged == true) {
          return {
            hasError: false,
            return: true,
            Message: `The Price of this Flight is ${changeIdentifier} by Rs. ${priceChanged}`,
          };
        }
      }
    } else {
      if (FlightDetail[0].SellResponse.IsPriceChanged == true) {
        return {
          hasError: false,
          return: true,
          Message: `The Price of this Flight is ${FlightDetail[0].SellResponse.priceChangeIdentifier} by Rs. ${FlightDetail[0].SellResponse.AmountChanged}`,
        };
      }
    }
  } else if (SearchResultType == 7 || SearchResultType == 8) {
    if (FlightDetail[0] == undefined) {
      if (
        FlightDetail.Connections[0].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[1].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[2].SellResponse.IsPriceChanged == true
      ) {
        let OriginalPriceEarlier1 =
            FlightDetail.Connections[0].Fare.BaseFare +
            FlightDetail.Connections[0].Fare.Tax,
          OriginalPriceEarlier2 =
            FlightDetail.Connections[1].Fare.BaseFare +
            FlightDetail.Connections[1].Fare.Tax,
          OriginalPriceEarlier3 =
            FlightDetail.Connections[2].Fare.BaseFare +
            FlightDetail.Connections[2].Fare.Tax;

        if (FlightDetail.Connections[0].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[0].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[0].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier1 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier1 - priceChanged
              : OriginalPriceEarlier1 + priceChanged;
        }

        if (FlightDetail.Connections[1].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[1].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[1].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier2 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier2 - priceChanged
              : OriginalPriceEarlier2 + priceChanged;
        }

        if (FlightDetail.Connections[2].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[2].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[2].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier3 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier3 - priceChanged
              : OriginalPriceEarlier3 + priceChanged;
        }

        let combinedSum =
          FlightDetail.Connections[0].Fare.BaseFare +
          FlightDetail.Connections[0].Fare.Tax +
          FlightDetail.Connections[1].Fare.BaseFare +
          FlightDetail.Connections[1].Fare.Tax +
          FlightDetail.Connections[2].Fare.BaseFare +
          FlightDetail.Connections[2].Fare.Tax;

        let isPriceChanged =
          combinedSum !=
          OriginalPriceEarlier1 + OriginalPriceEarlier2 + OriginalPriceEarlier3;

        let priceChanged =
          combinedSum >
          OriginalPriceEarlier1 + OriginalPriceEarlier2 + OriginalPriceEarlier3
            ? combinedSum -
              OriginalPriceEarlier1 +
              OriginalPriceEarlier2 +
              OriginalPriceEarlier3
            : OriginalPriceEarlier1 +
              OriginalPriceEarlier2 +
              OriginalPriceEarlier3 -
              combinedSum;

        let changeIdentifier =
          combinedSum <
          OriginalPriceEarlier1 + OriginalPriceEarlier2 + OriginalPriceEarlier3
            ? "Decreased"
            : "Increased";

        if (isPriceChanged == true) {
          return {
            hasError: false,
            return: true,
            Message: `The Price of this Flight is ${changeIdentifier} by Rs. ${priceChanged}`,
          };
        }
      }
    } else {
      if (FlightDetail[0].SellResponse.IsPriceChanged == true) {
        return {
          hasError: false,
          return: true,
          Message: `The Price of this Flight is ${FlightDetail[0].SellResponse.priceChangeIdentifier} by Rs. ${FlightDetail[0].SellResponse.AmountChanged}`,
        };
      }
    }
  } else if (SearchResultType == 9) {
    if (FlightDetail[0] == undefined) {
      if (
        FlightDetail.Connections[0].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[1].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[2].SellResponse.IsPriceChanged == true ||
        FlightDetail.Connections[3].SellResponse.IsPriceChanged == true
      ) {
        let OriginalPriceEarlier1 =
            FlightDetail.Connections[0].Fare.BaseFare +
            FlightDetail.Connections[0].Fare.Tax,
          OriginalPriceEarlier2 =
            FlightDetail.Connections[1].Fare.BaseFare +
            FlightDetail.Connections[1].Fare.Tax,
          OriginalPriceEarlier3 =
            FlightDetail.Connections[2].Fare.BaseFare +
            FlightDetail.Connections[2].Fare.Tax,
          OriginalPriceEarlier4 =
            FlightDetail.Connections[3].Fare.BaseFare +
            FlightDetail.Connections[3].Fare.Tax;

        if (FlightDetail.Connections[0].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[0].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[0].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier1 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier1 - priceChanged
              : OriginalPriceEarlier1 + priceChanged;
        }

        if (FlightDetail.Connections[1].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[1].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[1].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier2 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier2 - priceChanged
              : OriginalPriceEarlier2 + priceChanged;
        }

        if (FlightDetail.Connections[2].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[2].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[2].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier3 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier3 - priceChanged
              : OriginalPriceEarlier3 + priceChanged;
        }

        if (FlightDetail.Connections[3].SellResponse.IsPriceChanged == true) {
          let priceChanged =
            FlightDetail.Connections[3].SellResponse.AmountChanged;
          let changeIdentifier =
            FlightDetail.Connections[3].SellResponse.priceChangeIdentifier;

          OriginalPriceEarlier4 =
            changeIdentifier == "Increased"
              ? OriginalPriceEarlier4 - priceChanged
              : OriginalPriceEarlier4 + priceChanged;
        }

        let combinedSum =
          FlightDetail.Connections[0].Fare.BaseFare +
          FlightDetail.Connections[0].Fare.Tax +
          FlightDetail.Connections[1].Fare.BaseFare +
          FlightDetail.Connections[1].Fare.Tax +
          FlightDetail.Connections[2].Fare.BaseFare +
          FlightDetail.Connections[2].Fare.Tax +
          FlightDetail.Connections[3].Fare.BaseFare +
          FlightDetail.Connections[3].Fare.Tax;

        let isPriceChanged =
          combinedSum !=
          OriginalPriceEarlier1 +
            OriginalPriceEarlier2 +
            OriginalPriceEarlier3 +
            OriginalPriceEarlier4;

        let priceChanged =
          combinedSum >
          OriginalPriceEarlier1 +
            OriginalPriceEarlier2 +
            OriginalPriceEarlier3 +
            OriginalPriceEarlier4
            ? combinedSum -
              OriginalPriceEarlier1 +
              OriginalPriceEarlier2 +
              OriginalPriceEarlier3 +
              OriginalPriceEarlier4
            : OriginalPriceEarlier1 +
              OriginalPriceEarlier2 +
              OriginalPriceEarlier3 +
              OriginalPriceEarlier4 -
              combinedSum;

        let changeIdentifier =
          combinedSum <
          OriginalPriceEarlier1 +
            OriginalPriceEarlier2 +
            OriginalPriceEarlier3 +
            OriginalPriceEarlier4
            ? "Decreased"
            : "Increased";

        if (isPriceChanged == true) {
          return {
            hasError: false,
            return: true,
            Message: `The Price of this Flight is ${changeIdentifier} by Rs. ${priceChanged}`,
          };
        }
      }
    } else {
      if (FlightDetail[0].SellResponse.IsPriceChanged == true) {
        return {
          hasError: false,
          return: true,
          Message: `The Price of this Flight is ${FlightDetail[0].SellResponse.priceChangeIdentifier} by Rs. ${FlightDetail[0].SellResponse.AmountChanged}`,
        };
      }
    }
  }

  return {
    hasError: false,
    return: false,
    Message: ``,
  };
};

// See ResultPage-Flights-SLICE.js's getUrlParams for the full explanation — fixed-width
// substring(19,21)/substring(22,25) silently misread the country codes whenever the itr segment's
// date portion wasn't exactly 10 characters ("DD-MM-YYYY"), e.g. a single-digit day/month. Country
// codes are always the LAST two dash-separated tokens regardless of the date's digit padding.
let isInternationalTrip = (item) => {
  const parts = item.split("-");
  return parts[parts.length - 2] !== parts[parts.length - 1];
};

let getTheResultType = (itrData) => {
  if (itrData?.length === 1) {
    let isInternational = isInternationalTrip(itrData[0]);

    if (isInternational === true) {
      return 2;
    }
    return 1;
  } else if (itrData?.length === 2) {
    if (
      itrData[0].substring(0, 3) === itrData[1].substring(4, 7) &&
      itrData[0].substring(4, 7) === itrData[1].substring(0, 3)
    ) {
      let isInternational = isInternationalTrip(itrData[0]);

      if (isInternational === true) {
        return 4;
      }
      return 3;
    } else {
      let isInternational1 = isInternationalTrip(itrData[0]);
      let isInternational2 = isInternationalTrip(itrData[1]);

      if (isInternational1 === true || isInternational2 === true) {
        return 6;
      }
      return 5;
    }
  } else if (itrData?.length === 3) {
    let isInternational1 = isInternationalTrip(itrData[0]);
    let isInternational2 = isInternationalTrip(itrData[1]);
    let isInternational3 = isInternationalTrip(itrData[2]);

    if (
      isInternational1 === true ||
      isInternational2 === true ||
      isInternational3 === true
    ) {
      return 8;
    }
    return 7;
  } else if (itrData?.length === 4) {
    let isInternational1 = isInternationalTrip(itrData[0]);
    let isInternational2 = isInternationalTrip(itrData[1]);
    let isInternational3 = isInternationalTrip(itrData[2]);
    let isInternational4 = isInternationalTrip(itrData[3]);

    if (
      isInternational1 === true ||
      isInternational2 === true ||
      isInternational3 === true ||
      isInternational4 === true
    ) {
      return 10;
    }
    return 9;
  }
};

export const Call_Hold_and_Sell = async (isUserLogin, url, Prev_booking_id) => {
  console.log("url is : ", url);

  const token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
  const response = await getBookingDetailed(Prev_booking_id, token);

  console.log("bookingData receevied is : ", response);

  if (!response.error) {
    let bookingData = response.data.booking;

    console.log("bookingData receevied is : ", bookingData);

    try {
      let params = new URL(url).searchParams;
      let itr = params.get("itr");
      let sri = params.get("sri");
      let dti = params.get("dti");

      let soldParams = {
        ItenaryID: itr,
        SearchId: sri,
      };

      console.log("soldParams is : ", soldParams);

      let soldData = await SellTheFlightAPI(soldParams);

      console.log("soldData is : ", soldData);

      let flightData = await GetTheFlight(soldData.data.bid);

      console.log("flightData here is: ", flightData.data.flight_data);

      // Decrypt the data
      const secretKey = "your-secret-key"; // Replace with your own secret key
      const ThemeData = JSON.parse(
        CryptoJS.AES.decrypt(decodeURIComponent(dti), secretKey).toString(
          CryptoJS.enc.Utf8
        )
      );

      let SearchResultType = getTheResultType(ThemeData.itrCode.split("|"));

      //   console.log("SearchResultType, flightData.data is : " , SearchResultType, flightData.data);

      let resultMain = InitializePopup(
        SearchResultType,
        flightData.data.flight_data
      );

      let continue1_params = {
        CC: bookingData.policies.coupons_and_discounts_used || null,
        Booking_id: soldData.data.bid,
        url: window.location.href,
      };

      if (resultMain.return == true) {
        return {
          ...response,
          onClickContinue: {
            functionName: "Call_Continue1",
            bookingData,
            soldData,
            continue1_params,
          },
        };
      }

      return Call_Continue1(bookingData, soldData, continue1_params);
    } catch (error) {
      console.log("error is : ", error);

      return {
        hasError: true,
        return: true,
        Heading: "Error",
        Message: "Error Occured ! Contact Support or Try again later",
        showContinue: false,
        continueButtonText: "",
      };
    }
  } else {
    console.log("error is ");
    alert("here");
    return {
      hasError: true,
      return: true,
      Heading: "Error",
      Message: "Error Occured ! Contact Support or Try again later",
      showContinue: false,
      continueButtonText: "",
    };
  }
};

export const Call_Continue1 = async (
  bookingData,
  soldData,
  continue1_params
) => {
  try {
    await callContinue1(continue1_params);

    let paramsToContinue = {
      CC: bookingData.policies.coupons_and_discounts_used || null,
      Booking_id: soldData.data.bid,
      main: bookingData.data.traveller_data.main,
      travellers: bookingData.data.traveller_data.registered,
      user_name: `${bookingData.data.traveller_data.registered[0].firstName} ${bookingData.data.traveller_data.registered[0].lastName}`,
      email: bookingData.booker_email,
      phone: bookingData.booker_phone,
      ancellariesCodes: bookingData.data.traveller_data.ancellariesCodes,
      saveKey: "registered",
    };

    try {
      await callContinue2(paramsToContinue);

      let response = Call_Continue3(soldData.data.bid, bookingData);

      if (response.return == true) {
        return {
          ...response,
          onClickContinue: {
            functionName: "Call_Continue3",
            booking_id: soldData.data.bid,
            bookingData: bookingData,
          },
        };
      }

      return {
        hasError: false,
      };
    } catch (e) {
      console.log("error is : ", e);

      return {
        hasError: true,
        return: true,
        Heading: "Error",
        Message: "Error Occured ! Contact Support or Try again later",
        showContinue: false,
        continueButtonText: "",
      };
    }
  } catch (error) {
    console.log("error is : ", error);

    return {
      hasError: true,
      return: true,
      Heading: "Error",
      Message: "Error Occured ! Contact Support or Try again later",
      showContinue: false,
      continueButtonText: "",
    };
  }
};

export const Call_Continue3 = async (booking_id, bookingData) => {
  let proceedParams = {
    BookingId: booking_id,
    SearchId: bookingData.data.search_id,
    travellers: {
      data: bookingData.data.traveller_data.registered,
      contactInfo: {
        email: bookingData.booker_email,
        phone: bookingData.booker_phone,
      },
    },
    ancellariesCodes: bookingData.data.traveller_data.ancellariesCodes,
    discountCoupon: {
      isAdded: false,
    },
    zeroCancellation: {
      isAdded: false,
    },
    insurance: {
      isAdded: false,
    },
  };

  try {
    // call proceed to pay api and handle it all here
    let proceededData = await callProceedToPay(proceedParams);

    console.log("proceededData is : ", proceededData);
    proceededData = proceededData.data;

    if (proceededData.redirectToPaymentPage == false) {
      // show that reason

      if (proceededData.code == "HF" || proceededData.code == "HS") {
        return {
          hasError: true,
          return: true,
          Heading: proceededData.CodeName == "HS" ? "Information" : proceededData.CodeName,
          Message: proceededData.Message,
          showContinue: false,
          continueButtonText: "",
        };
      }
      if (proceededData.code == "IVL" || proceededData.code == "FNA") {
        return {
          hasError: true,
          return: true,
          Heading: "Link expired",
          Message: "You can start your search again and complete your booking",
          showContinue: false,
          continueButtonText: "",
        };
      }
      if (proceededData.code == "SE") {
        return {
          hasError: true,
          return: true,
          Heading: "Session expired",
          Message: "You can start your search again and complete your booking",
          showContinue: false,
          continueButtonText: "",
        };
      } else if (proceededData.code == "TE" || proceededData.code == "TVA") {
        return {
          hasError: true,
          return: true,
          Heading: "Technical Error",
          Message: "Technical Error ! Please Try Again Later",
          showContinue: false,
          continueButtonText: "",
        };
      } else if (proceededData.code == "TVM") {
        return {
          hasError: true,
          return: true,
          Heading: "Invalid Travellers",
          Message: proceededData.Message,
          showContinue: false,
          continueButtonText: "",
        };
      } else if (proceededData.code == "RBTC") {
        return {
          hasError: true,
          return: true,
          Heading: proceededData.CodeName,
          Data: proceededData.Message,
          showContinue: false,
          continueButtonText: "",
        };
      } else if (proceededData.code === "ANCE") {
        return {
          hasError: true,
          return: true,
          Heading: proceededData.CodeName,
          Data: proceededData.Message,
          showContinue: true,
          continueButtonText: proceededData.CodeName.includes("Bag")
            ? "Bags"
            : proceededData.CodeName.includes("Seat")
            ? "Seats"
            : proceededData.CodeName.includes("Meal")
            ? "Meals"
            : proceededData.CodeName,
        };
      } else if (proceededData.code === "PC") {
        return {
          hasError: true,
          return: true,
          Heading: proceededData.CodeName,
          Message: `The Price of this Flight is ${proceededData.Message.priceStatus} . Old Price was Rs . ${proceededData.Message.oldPrice} , Current Price of the Flight is Rs . ${proceededData.Message.newPrice}`,
          showContinue: true,
          continueButtonText: "Want To Continue ?",
        };
      }
    } else {
      const token = getLocalStorageJSON("UL");
      let resp = await UpdateBookingStatus(bookingData.booking_id, token);

      if (resp.error == true) {
        return {
          hasError: true,
          return: true,
          Heading: "Error",
          Message: "Error Occured ! Contact Support or Try again later",
          showContinue: false,
          continueButtonText: "",
        };
      }

      let paymentId = proceededData.Message.payment_id;

      window.location.href = `${MAIN_PAYMENT_URL}id=${paymentId}`;
    }
  } catch (e) {
    console.log("the erorro proceed toi pay here is : ", e);

    return {
      hasError: true,
      return: true,
      Heading: "Error",
      Message: "Technical Error ! Please Try Again Later",
      showContinue: false,
      continueButtonText: "",
    };
  }
};
